import React from 'react'
import {connect} from 'react-redux'

// Views
import MileageImportViewBase from 'mrshoebox-ui-components/src/modules/DriverLogs/views/DriverLogImportView'

// Actions
import { addMileageReportsAction } from 'Projects/actions/project'
import { reloadDriverLogsListAction, extendDriverLogsListAction } from 'MileageReports/actions/mileageReports'
import { routerActions } from 'react-router-redux'

const MileageImportView = (props) => (
  <MileageImportViewBase
    {...props}
    reloadListAction={reloadDriverLogsListAction()}
    extendListAction={extendDriverLogsListAction()}
  />
)

function mapStateToProps () {
  return {
    withAddButton: true,
    cameFrom: 'project'
  }
}

function mapDispatchToProps (dispatch) {
  return {
    importItemsToForm: (reports) => { dispatch([addMileageReportsAction(reports), routerActions.goBack()]) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MileageImportView)
